@use 'src/globals/main';

pn-search-field {
  display: inline-flex;
  gap: 0.5em;
}

pn-search-field input {
  @include main.pn-input-field;

  min-height: 3em;
  height: 100%;
  width: 100%;
  border-radius: 3em;

  &::-webkit-search-cancel-button {
    display: none;
  }
}

pn-search-field > .input-container {
  width: 100%;
  position: relative;

  .button-container {
    position: absolute;
    top: 0;
    right: 0;
    background: transparent;
    width: 3em;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  pn-button {
    position: absolute;
    left: 50%;
    top: 50%;

    @include main.pn-transition('transform');
    transition-delay: main.$timing;
    transform: translate(100%, -50%);
  }
}

pn-search-field.searching {
  pn-button.search {
    transform: translate(150%, -50%);
  }
  pn-button.clear {
    transform: translate(-50%, -50%);
  }
}

/*---------------------------------------Button Variants-------------------------------------------*/
pn-search-field.button-none,
pn-search-field.button-icon-inline {
  input {
    padding-right: 2em;
  }

  pn-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transition: transform main.$easing main.$timing;
    transform: translate(100%, -50%);
  }

  pn-button.search {
    transform: translate(-50%, -50%);
  }

  &.loading {
    pn-button {
      transform: translate(100%, -50%);
    }

    pn-spinner {
      transform: translate(-50%, -50%);
    }
  }
}

pn-search-field.button-none.searching pn-button.search {
  transform: translate(100%, -50%);
}

pn-search-field.button-icon > pn-button {
  &[data-loading='true'] {
    .pn-button-bg {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
/*---------------------------------------/Button Variants-------------------------------------------*/
